import { render, staticRenderFns } from "./CmgBag.vue?vue&type=template&id=678a5e80&scoped=true&lang=pug&"
import script from "./cmg-bag.ts?vue&type=script&lang=ts&"
export * from "./cmg-bag.ts?vue&type=script&lang=ts&"
import style0 from "./CmgBag.vue?vue&type=style&index=0&id=678a5e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678a5e80",
  null
  
)

export default component.exports